export default __webpack_public_path__ + "static/media/093-resize.4089b1a5.png";